import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import ConfirmImportComponent from './ConfirmImport.component';
import Project from 'src/entities/Project';
import Investment from 'src/entities/Investment';
import { openModal, OpenModal } from 'src/actions/modal';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import ChangeAmountContainer from 'src/modules/modals/change-amount/ChangeAmount.container';

interface StateProps {
  project?: Project;
}

interface State {
  questionId?: boolean;
}

interface DispatchProps {
  openModal: (component: JSX.Element, className: string) => void;
}

export interface OwnProps {
  modalRef?: Modal;
}

interface Props extends StateProps, DispatchProps, OwnProps {
  investment: Investment;
  setInvestment(investment: Investment, step: string): void;
}

class ConfirmImportContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public render(): React.ReactNode {
    return (
      (!this.props.project) ?
        null :
        (
          <ConfirmImportComponent
            project={this.props.project}
            questionId={this.state.questionId}
            handleConfirmImport={() => this.handleConfirmImport()}
            handleModifyImport={() => this.handleModifyImport()}
            investment={this.props.investment}
            handleQuestion={(id: boolean) => this.handleQuestion(id)}
          />
        )
    );
  }

  private handleConfirmImport(): void {
    const investment: Investment = {
      ...this.props.investment!,
      status: 'Confirmed Amount',
      amountInvested:
        ((1.21 * 0.02 + 1) * this.props.investment.amountInvested),
        essentialAsset: this.state.questionId,
    };
    this.props.setInvestment(investment, investment.status!);
  }

  private handleModifyImport(): void {
    this.props.openModal(
      <ChangeAmountContainer
        modalRef={this.props.modalRef}
        investment={this.props.investment}
        project={this.props.project!}
      />,
      'large'
    );
  }

  private handleQuestion(id: boolean): void {
    this.setState({
      questionId: id
    });
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element, className: string): OpenModal => {
    return dispatch(openModal(component, className));
  }

});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  project: state.getProject.project
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmImportContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/confirm-import/ConfirmImport.container.tsx